import React from 'react';
import { Switch, Route } from 'react-router-dom';

import HomePage from './pages/homepage/homepage.component';
// import LiberaryPage from './pages/liberarypage/liberarypage.component';
import BookReviewPage from './pages/bookreviewpage/bookreviewpage.component';
import BookViewQuran from './pages/bookviewquran/bookviewquran.component';
import SectionLiberaryViewPage from './pages/sectionliberaryviewpage/sectionliberaryviewpage.component';
import LoadingPage from './components/loading/loadingpage.component';
import SectionPage from './pages/sections/sectionspage';
// import DarViewer from './components/darReview/dar-view.component';
import PrayerPage from './pages/prayerpage/prayerpage.component';

import './App.css';
import Header from './components/header/header.component';
import Navbar from './components/header.nav.component/header.nav.component';
import Footer from './components/footer/footer.component';

const newRegister = () => {
  const url = 'https://docs.google.com/forms/d/e/1FAIpQLSfNr4MC-i4Z6aCIHlcWc_pg6RBuyKjB8CNsrhCUmKBYQw5ZOQ/viewform?usp=pp_url';
  return(
    <div>
      <h1>في الذاكره</h1>
      <div>
        <iframe 
            width="85%" 
            height="650" 
            id="gmap_canvas" 
            frameBorder="10px"
            src = {url} 
            frameBorder="0"  marginHeight="0" marginWidth="0">
        </iframe>
      </div>
      <br/><br/>
    </div>
    
  );
};

const appstore = () => {
  const url = 'https://www.google.com/url?sa=i&url=https%3A%2F%2Fapps.apple.com%2Fus%2Fapp%2Fdarquranfahd%2Fid1491442944&psig=AOvVaw1iAOHNZ5a74QdIMDEVP3_F&ust=1596641904467000&source=images&cd=vfe&ved=2ahUKEwjGgtXd8IHrAhUv1uAKHe2EBTMQr4kDegUIARCUAQ'; 
  window.open(url, '_blank', 'location=yes,innerHeight=500,innerWidth500,scrollbars=yes,status=yes');
          return (<LoadingPage/>);
};

const googleplay = () => {
  const url = 'https://play.google.com/store/apps/details?id=dar.quran.fahd&hl=en';
  window.open(url, '_blank', 'location=yes,innerHeight=500,innerWidth500,scrollbars=yes,status=yes');
          return (<LoadingPage/>);
};

const viewIslamicSMS = () => {
  const url = 'https://islamic-sms.netlify.app'; 
  // window.open(url, '_blank', 'location=yes,innerHeight=500,innerWidth500,scrollbars=yes,status=yes');
  //         return (<LoadingPage/>);
  return(
      <div>
        <iframe 
            width="100%" 
            height="680" 
            id="gmap_canvas" 
            frameBorder="10px"
            src = {url} 
            frameBorder="0"  marginHeight="0" marginWidth="0">
        </iframe>
        <br/><br/>
      </div>
  );

};

const viewIslamicTheEND = () => {
  const url = 'https://islamic-the-end.netlify.app'; 
  // window.open(url, '_blank', 'location=yes,innerHeight=500,innerWidth500,scrollbars=yes,status=yes');
  //         return (<LoadingPage/>);
  return(
      <div>
        <iframe 
            width="100%" 
            height="680" 
            id="gmap_canvas" 
            frameBorder="10px"
            src = {url} 
            frameBorder="0"  marginHeight="0" marginWidth="0">
        </iframe>
        <br/><br/>
      </div>
  );

};

function App (){ 
  return(
    <div className = 'App'>
      {/* <Header/> */}
      <Navbar/>
        <Switch>
          <Route exact path= '/' component={HomePage}/>
          {/* <Route path= '/library' component={LiberaryPage}/> */}
          <Route path='/sections' component={SectionPage}/>
          <Route path='/viewsection/:blink' component={SectionLiberaryViewPage}/>
          <Route path='/viewbook/:blink' component={BookReviewPage}/>
          <Route path='/newRegister' component={newRegister}/>
          <Route path='/googleplay' component={googleplay}/>
          <Route path='/appstore' component={appstore}/>
          <Route path='/prayertime' component={PrayerPage}/>
          <Route path='/quran' component={BookViewQuran}/>
          <Route path='/islamicsms' component={viewIslamicSMS}/>
          <Route path='/islamictheend' component={viewIslamicTheEND}/>
        </Switch>
      <Footer/>
    </div>
  );
}
export default App;
